import React, { useState, useCallback } from 'react'

import { Grid } from '@material-ui/core'
import LoadingBackdrop from 'shared/components/LoadingBackdrop'
import Switch from 'shared/components/Switch'
import { colors } from 'shared/styles/colors'

import Modal from 'shared/components/Modal'
import { IDetalhesProps } from './DetalhesComponent.types'
import { Title, Field, Value, Label, StyledContainerSwitch } from './styles'
import SnackBar from 'shared/components/SnackBar'
import IActiveOrInactiveDTO from 'modules/veiculos/domain/dtos/IActiveOrInactiveDTO'

export const Detalhes: React.FC<IDetalhesProps> = ({
  veiculo,
  openModal,
  onCloseModal,
  activeOrInactive,
}) => {
  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [openAlert, setOpenAlert] = useState(false)

  const handleChangeStatus = useCallback(async () => {
    setLoading(true)
    veiculo.ativo = !veiculo.ativo

    const params: IActiveOrInactiveDTO = {
      veiculo: veiculo,
    }

    try {
      await activeOrInactive.execute(params)

      setLoading(false)
      onCloseModal()
    } catch (e: unknown) {
      veiculo.ativo = !veiculo.ativo
      if (e instanceof Error) {
        setErrorMessage(e.message)
      }
      setOpenAlert(true)
      setLoading(false)
    }
  }, [veiculo, activeOrInactive, onCloseModal])

  return (
    <>
      <Modal
        openModal={openModal}
        showCloseButton={true}
        size="large"
        onCloseModal={onCloseModal}
      >
        <StyledContainerSwitch>
          <Label>Status</Label>
          <Switch
            id="status"
            checked={veiculo ? veiculo.ativo : false}
            onChange={handleChangeStatus}
          />
        </StyledContainerSwitch>
        <Grid container spacing={3}>
          {veiculo?.tipo === 'CAVALO' && (
            <>
              <Grid container>
                <Grid item xs={12}>
                  <Title style={{ marginTop: '30px' }}>Dados cavalo</Title>
                </Grid>
              </Grid>

              <Grid container>
                <Grid item xs={3}>
                  <Field>Placa do cavalo</Field>
                </Grid>
                <Grid item xs={3}>
                  <Field>RENAVAM</Field>
                </Grid>
                <Grid item xs={3}>
                  <Field>Local de emissão</Field>
                </Grid>
                <Grid item xs={3}>
                  <Field>CNPJ</Field>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={3}>
                  <Value>{veiculo?.placa}</Value>
                </Grid>
                <Grid item xs={3}>
                  <Value>{veiculo?.renavam}</Value>
                </Grid>
                <Grid item xs={3}>
                  <Value>{veiculo?.local_emissao}</Value>
                </Grid>
                <Grid item xs={3}>
                  <Value>{veiculo?.frotista?.cnpj}</Value>
                </Grid>
              </Grid>

              <Grid container>
                <Grid item xs={3}>
                  <Field>País</Field>
                </Grid>
                <Grid item xs={3}>
                  <Field>Padrão MERCOSUL</Field>
                </Grid>
                <Grid item xs={3}>
                  <Field>Chassi</Field>
                </Grid>
              </Grid>

              <Grid container>
                <Grid item xs={3}>
                  <Value>BRASIL</Value>
                </Grid>
                <Grid item xs={3}>
                  <Value>
                    {veiculo?.placa
                      ? (veiculo?.placa.match(/\d/g) || []).length > 3
                        ? 'INATIVO'
                        : 'ATIVO'
                      : ' '}
                  </Value>
                </Grid>
                <Grid item xs={3}>
                  <Value>{veiculo?.chassi}</Value>
                </Grid>
              </Grid>
            </>
          )}

          {veiculo?.tipo === 'CARRETA' && (
            <>
              <Grid container>
                <Grid item xs={12}>
                  <Title style={{ marginTop: '30px' }}>Dados carreta</Title>
                </Grid>
              </Grid>

              <Grid container>
                <Grid item xs={4}>
                  <Field>Placa do cavalo</Field>
                </Grid>
                <Grid item xs={4}>
                  <Field>Tipo de carreta</Field>
                </Grid>
                <Grid item xs={4}>
                  <Field>CNPJ</Field>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={4}>
                  <Value>{veiculo?.placa}</Value>
                </Grid>
                <Grid item xs={4}>
                  <Value>{veiculo?.tipoCarreta?.descricao}</Value>
                </Grid>
                <Grid item xs={4}>
                  <Value>{veiculo?.frotista?.cnpj}</Value>
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
      </Modal>
      {loading && <LoadingBackdrop open={loading} color={colors.green} />}
      <SnackBar
        open={openAlert}
        setOpen={setOpenAlert}
        severity="error"
        message={errorMessage}
      />
    </>
  )
}

export default Detalhes
